import React, { useState } from 'react';
import styles from '../../styles/CambioGrupoStyles/CambioGrupo.module.css';

function StudentChangeForm({ student, onBack, onSubmit }) {
  const [formData, setFormData] = useState({
    cicloEscolar: '2025-T3',
    materia: '',
    grupoOrigen: 'G-035',
    grupoDestino: '',
    motivoCambio: '',
    fechaCambio: '20/11/2025',
    observaciones: '',
    autorizadoPor: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      student: student
    });
  };

  return (
    <div className={styles.changeFormContainer}>
      {/* Back Button */}
      <button className={styles.backButton} onClick={onBack}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M19 12H5"/>
          <path d="M12 19l-7-7 7-7"/>
        </svg>
        Volver a búsqueda
      </button>

      {/* Search Section Header */}
      <div className={styles.searchSection}>
        <div className={styles.searchHeader}>
          <div className={styles.searchIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </div>
          <h2 className={styles.searchTitle}>Búsqueda de Estudiante</h2>
        </div>
        
        <div className={styles.filtersRow}>
          <div className={styles.filterGroup}>
            <label className={styles.filterLabel}>Campus</label>
            <select className={styles.filterSelect} disabled>
              <option>Venustiano Carranza</option>
            </select>
          </div>
          
          <div className={styles.filterGroup}>
            <label className={styles.filterLabel}>Sección</label>
            <select className={styles.filterSelect} disabled>
              <option>Licenciatura</option>
            </select>
          </div>
          
          <div className={styles.searchInputContainer}>
            <div className={styles.searchInputIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
            </div>
            <input
              type="text"
              className={styles.searchInput}
              value={`Buscar Alumno por Matrícula o Nombre`}
              disabled
            />
          </div>
          
          <button className={styles.searchButton} disabled>
            BUSCAR
          </button>
          
          <button className={styles.resetButton}>
            REGRESAR
          </button>
        </div>
      </div>

      {/* Student Info Card */}
      <div className={styles.studentInfoSection}>
        <div className={styles.studentHeader}>
          <h3>Estudiante: {student.nombre}</h3>
        </div>
        
        <div className={styles.studentCard}>
          <div className={styles.studentAvatar}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          
          <div className={styles.studentData}>
            <div className={styles.studentDataRow}>
              <div className={styles.dataColumn}>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Matrícula</span>
                  <span className={styles.dataValue}>{student.matricula}</span>
                </div>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Sección</span>
                  <span className={styles.dataValue}>{student.seccion}</span>
                </div>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Programa</span>
                  <span className={styles.dataValue}>{student.programa}</span>
                </div>
              </div>
              
              <div className={styles.dataColumn}>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Período actual</span>
                  <span className={styles.dataValue}>{student.periodoActual}</span>
                </div>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Institución</span>
                  <span className={styles.dataValue}>{student.institucion}</span>
                </div>
                <div className={styles.dataItem}>
                  <span className={styles.dataLabel}>Campus</span>
                  <span className={styles.dataValue}>{student.campus} Carranza</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Change Form */}
      <div className={styles.changeFormSection}>
        <div className={styles.changeFormHeader}>
          <div className={styles.changeFormIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <h3 className={styles.changeFormTitle}>Cambio de Grupo</h3>
        </div>
        
        <form onSubmit={handleSubmit} className={styles.changeForm}>
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Ciclo Escolar</label>
              <select 
                className={styles.formSelect}
                value={formData.cicloEscolar}
                onChange={(e) => handleInputChange('cicloEscolar', e.target.value)}
              >
                <option value="2025-T3">2025-T3</option>
                <option value="2025-T2">2025-T2</option>
                <option value="2025-T1">2025-T1</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Materia</label>
              <select 
                className={styles.formSelect}
                value={formData.materia}
                onChange={(e) => handleInputChange('materia', e.target.value)}
              >
                <option value="">- Seleccionar materia -</option>
                <option value="Cálculo">Cálculo</option>
                <option value="Álgebra">Álgebra</option>
                <option value="Física">Física</option>
                <option value="Programación">Programación</option>
              </select>
            </div>
          </div>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Grupo Origen</label>
              <select 
                className={styles.formSelect}
                value={formData.grupoOrigen}
                onChange={(e) => handleInputChange('grupoOrigen', e.target.value)}
              >
                <option value="G-035">G-035</option>
                <option value="G-036">G-036</option>
                <option value="G-037">G-037</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Grupo Destino</label>
              <select 
                className={styles.formSelect}
                value={formData.grupoDestino}
                onChange={(e) => handleInputChange('grupoDestino', e.target.value)}
              >
                <option value="">- Seleccionar grupo -</option>
                <option value="G-126 (22/30 Estudiantes)">G-126 (22/30 Estudiantes)</option>
                <option value="G-127 (18/30 Estudiantes)">G-127 (18/30 Estudiantes)</option>
                <option value="G-128 (25/30 Estudiantes)">G-128 (25/30 Estudiantes)</option>
              </select>
            </div>
          </div>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Motivo de cambio</label>
              <select 
                className={styles.formSelect}
                value={formData.motivoCambio}
                onChange={(e) => handleInputChange('motivoCambio', e.target.value)}
              >
                <option value="">- Seleccionar -</option>
                <option value="Conflicto de horario">Conflicto de horario</option>
                <option value="Solicitud del estudiante">Solicitud del estudiante</option>
                <option value="Cambio administrativo">Cambio administrativo</option>
                <option value="Problema académico">Problema académico</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Fecha de cambio</label>
              <div className={styles.dateInputContainer}>
                <input
                  type="text"
                  className={styles.dateInput}
                  value={formData.fechaCambio}
                  onChange={(e) => handleInputChange('fechaCambio', e.target.value)}
                />
                <div className={styles.dateIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Observaciones</label>
              <textarea
                className={styles.formTextarea}
                value={formData.observaciones}
                onChange={(e) => handleInputChange('observaciones', e.target.value)}
                placeholder="Escribir observaciones..."
              />
            </div>
          </div>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Autorizado por:</label>
              <select 
                className={styles.formSelect}
                value={formData.autorizadoPor}
                onChange={(e) => handleInputChange('autorizadoPor', e.target.value)}
              >
                <option value="">- Seleccionar -</option>
                <option value="Director Académico">Director Académico</option>
                <option value="Coordinador de Programa">Coordinador de Programa</option>
                <option value="Administrador">Administrador</option>
              </select>
            </div>
          </div>
          
          <div className={styles.formActions}>
            <button type="submit" className={styles.applyButton}>
              APLICAR
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StudentChangeForm;
